import { render, staticRenderFns } from "./TemplateRecovery.vue?vue&type=template&id=5fba7704&scoped=true"
import script from "./TemplateRecovery.vue?vue&type=script&lang=js"
export * from "./TemplateRecovery.vue?vue&type=script&lang=js"
import style0 from "./TemplateRecovery.vue?vue&type=style&index=0&id=5fba7704&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fba7704",
  null
  
)

export default component.exports